import React from "react";
import { FormText } from "reactstrap";
import { PayorSelector as BasePayorSelector } from "../PayorSelector";
import { InputWrapper, serializeInput } from "./InputWrapper";

export const PayorSelector = ({ children, input, label, meta, inputId, ...rest }) => {
  const invalid = Boolean(meta.touched && meta.error);

  return (
    <InputWrapper testId={inputId || rest["data-testid"]} label={label} required={rest.required} htmlFor={inputId}>
      <BasePayorSelector {...input} {...rest} inputId={inputId} valid={!invalid} />

      {meta.touched && meta.error && <FormText color="danger">{meta.error}</FormText>}

      {children}
    </InputWrapper>
  );
};

export const SerializedPayorSelector = serializeInput(PayorSelector);
